import LogApprovalActions from './actions';

const INITIAL_STATE = {
  data: null,
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperLogApproval:[],
  errorInternal:false
};

function LogApprovalReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LogApprovalActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:null};
    case LogApprovalActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case LogApprovalActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case LogApprovalActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case LogApprovalActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case LogApprovalActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case LogApprovalActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case LogApprovalActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case LogApprovalActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case LogApprovalActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case LogApprovalActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case LogApprovalActions.GET_HELPER_LOGAPPROVAL:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperLogApproval:action.payload};
    case LogApprovalActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case LogApprovalActions.APPROVE:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
    case LogApprovalActions.REJECT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,};
     
    default:
      return state;
    }
}

export default LogApprovalReducer;
